<template>
  <v-container>
    <app-loading :loading="loading">
      <div>
        <app-header :buttonAction="action" backButton :backAction="backAction">
          <template #title>{{ data.title }}</template>
          <template #subtitle>{{ data.subtitle }}</template>
        </app-header>
        <app-explanation class="my-9">
          <template #body>{{ data.description }}</template>
        </app-explanation>
        <v-card
          class="half-radius shadow overflow-auto custom-scroll px-7"
          height="80vh"
          v-if="data.question_group"
        >
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" v-for="(answer, index) in answers" :key="'Question' + index">
                <app-pronunciation-card
                  :content="data.question_group.questions[index].content"
                  :src="data.question_group.questions[index].question_file"
                  :value="audios[index].audioBlob ? audios[index].audioBlob : answer.audio_file"
                  @input="onInput($event, index)"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <div class="d-flex justify-center mt-6">
          <v-btn
            v-if="!(!answers[0] || !!answers[0].uuid)"
            small
            depressed
            width="100"
            :loading="loadingSave"
            class="white--text text-capitalize"
            color="#29284c"
            @click="onSave"
            >Save</v-btn
          >
          <ProgressResetButton
            v-else
            stepType="PRACTICE_PRONUNCIATION"
            :stepUuid="data.uuid"
            @reset="onReset"
          />
        </div>
        <app-comment-group :uuid="data.comment_group" />
      </div>
    </app-loading>
    <app-student-note v-if="!isTeacher && qualification.note" :note="qualification.note" />
    <app-qualification
      v-if="isTeacher && !qualification.note && qualification.uuid"
      :qualification="qualification"
      @new-qual="qualification = $event"
    />
  </v-container>
</template>
<script>
import Header from "@/components/Lessons/Lesson/components/Header.vue";
import Explanation from "@/components/Lessons/Lesson/components/Explanation.vue";
import CommentGroup from "@/components/Lessons/Lesson/components/CommentGroup.vue";
import Loading from "@/components/Loading.vue";
import Qualification from "@/components/Utils/Qualification.vue";
import StudentNote from "@/components/Utils/StudentNote.vue";
import { getPronunciation, getAnswer, postAnswer, patchLessonProgress } from "@/api/api";
import studentMixin from "@/mixins/studentMixin";
import audioMixin from "@/mixins/audioMixin";
import PronunciationCard from "./PronunciationCard.vue";
import ProgressResetButton from "@/components/Utils/ProgressResetButton.vue";

export default {
  components: {
    appHeader: Header,
    appExplanation: Explanation,
    appCommentGroup: CommentGroup,
    appLoading: Loading,
    appQualification: Qualification,
    appStudentNote: StudentNote,
    appPronunciationCard: PronunciationCard,
    ProgressResetButton,
  },
  mixins: [studentMixin, audioMixin],
  data() {
    return {
      qualification: {},
      loading: true,
      data: {},
      answers: [],
      audios: [],
      loadingSave: false,
    };
  },
  methods: {
    onInput($event, index) {
      this.audios.splice(index, 1, {
        audioBlob: $event,
      });
    },
    async action() {
      this.$emit("next-step");
    },
    backAction() {
      this.$emit("prev-step");
    },
    onReset() {
      this.qualification = {};
      this.data = {};
      this.answers = [];
      this.audios = [];

      this.create();
    },
    async onSave() {
      try {
        this.loadingSave = true;

        for (let index = 0; index < this.answers.length; index++) {
          const element = this.answers[index];
          if (this.audios[index].audioBlob && !element.uuid) {
            element.audio_file = this.audios[index].audioBlob;
            const response = await postAnswer(element);
            if (response) {
              this.answers.splice(index, 1, response.data);
            }
          }
        }

        const progress = this.$store.getters["progress/lesson"];
        if (!progress.practice_progress.pronunciation_step) {
          progress.practice_progress.pronunciation_step = true;
          patchLessonProgress(progress).then((response) => {
            this.$store.commit("progress/lesson", response.data);
          });
        }

        this.qualification = await this.qualify();
      } finally {
        this.loadingSave = false;
      }
    },
    async create() {
      this.loading = true;

      let response = await getPronunciation(
        this.$store.getters["lesson/practice"].pronunciation_step,
      );
      this.data = response.data;

      for (let index = 0; index < this.data.question_group.questions.length; index++) {
        const element = this.data.question_group.questions[index];

        const response = await getAnswer({
          question__uuid: element.uuid,
          student__email: this.student.email,
        });
        this.audios.push({});
        if (response.data.count) {
          this.answers.push(response.data.results[0]);
        } else
          this.answers.push({
            question: element.uuid,
            student: this.student.email,
          });
      }

      this.qualification = await this.fetchQualification(
        this.student.email,
        this.data.question_group.uuid,
      );
      this.loading = false;
    },
  },
  async created() {
    this.create();
  },
};
</script>
